import React from 'react';
import RequestApprovalDialog from '../containers/RequestApprovalDialog';
import RequestDeletionDialog from '../containers/RequestDeletionDialog';
import RequestTransferDialog from '../containers/RequestTransferDialog';
import RequestArchivalDialog from '../containers/RequestArchivalDialog';
import RequestFormDialogs from '../forms/components/RequestFormDialogs';
import TaskDialogs from '../tasks/components/TaskDialogs';
import Selectors from '../hooks/selectors';

const RequestDialogs = ({ theme }) => {
  const {
    allowApprove, allowArchive, allowDelete, allowTransfer,
  } = Selectors.useRequestDialogs();

  return (
    <>
      <RequestFormDialogs theme={theme} />
      <TaskDialogs theme={theme} />
      {allowApprove && (<RequestApprovalDialog theme={theme} />)}
      {allowArchive && (<RequestArchivalDialog theme={theme} />)}
      {allowDelete && (<RequestDeletionDialog theme={theme} />)}
      {allowTransfer && (<RequestTransferDialog theme={theme} />)}
    </>
  );
};

export default RequestDialogs;
